export enum PaymentMethodEnum {
    PURCHASE_ORDER = 1,
    CREDIT_CARD = 3,
    BILL_WITHOUT_PO_NUMBER = 4,
    UNAVAILABLE = 12,
}
